module.exports = __webpack_public_path__ + "static/media/img-remove.03e00b8e.svg";